import { apiFetch } from '../../services/http';

export type AdSlot = {
  id: string;
  name: string;
  type: string;
  topicId: string;
  threadId?: string;
  status: string;
  minBidCents: number;
  currency: string;
  startTime: string;
  endTime: string;
  createdAt: string;
  updatedAt: string;
};

export type AdBid = {
  id: string;
  slotId: string;
  bidderAlias: string;
  amountCents: number;
  currency: string;
  creativeUrl?: string;
  targetUrl?: string;
  status: string;
  bidTime: string;
  createdAt: string;
};

export type AdPlacement = {
  id: string;
  slotId: string;
  bidId: string;
  bidderAlias: string;
  creativeUrl: string;
  targetUrl: string;
  status: string;
  startTime: string;
  endTime: string;
  impressions: number;
  clicks: number;
  createdAt: string;
  updatedAt: string;
};

export async function fetchSlots(limit = 50): Promise<AdSlot[]> {
  return apiFetch<AdSlot[]>(`/api/ads/slots?limit=${limit}`);
}

export async function fetchSlot(slotId: string): Promise<AdSlot> {
  return apiFetch<AdSlot>(`/api/ads/slots/${slotId}`);
}

export async function createSlot(payload: Partial<AdSlot>): Promise<AdSlot> {
  return apiFetch<AdSlot>(`/api/ads/slots`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchBidsForSlot(slotId: string, limit = 50): Promise<AdBid[]> {
  return apiFetch<AdBid[]>(`/api/ads/slots/${slotId}/bids?limit=${limit}`);
}

export async function createBid(payload: Partial<AdBid>): Promise<AdBid> {
  return apiFetch<AdBid>(`/api/ads/bids`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateBidStatus(bidId: string, status: string): Promise<void> {
  await apiFetch(`/api/ads/bids/${bidId}/status`, {
    method: 'POST',
    body: JSON.stringify({ status }),
  });
}

export async function fetchActivePlacements(topicId: string, limit = 50): Promise<AdPlacement[]> {
  return apiFetch<AdPlacement[]>(`/api/ads/placements?topicId=${encodeURIComponent(topicId)}&limit=${limit}`);
}

export async function createPlacement(payload: Partial<AdPlacement>): Promise<AdPlacement> {
  return apiFetch<AdPlacement>(`/api/ads/placements`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function recordImpression(placementId: string): Promise<void> {
  await apiFetch(`/api/ads/placements/${placementId}/impression`, {
    method: 'POST',
  });
}

export async function recordClick(placementId: string): Promise<void> {
  await apiFetch(`/api/ads/placements/${placementId}/click`, {
    method: 'POST',
  });
}

export async function fetchAdMetrics(): Promise<any> {
  return apiFetch(`/api/ads/metrics`);
}

export async function recordAdEvent(eventId: string, eventType: string): Promise<void> {
  await apiFetch(`/api/ads/events`, {
    method: 'POST',
    body: JSON.stringify({ eventId, eventType }),
  });
}
